import styled from 'styled-components';
import { COLORS } from '../../styles/variables';
import { device } from '../../styles/devices';
import { AlphaTheme } from '../../../design-system/ThemeProvider/alphaTheme';

export const MobileImage = styled.img`
  width: 100%;
`;

export const DesktopImageContainer = styled.div<{ isCaMarket?: boolean }>`
  max-width: 373px;
  @media ${device.laptopMd} {
    max-width: 480px;
  }
  background-color: ${({ theme }: { theme: Partial<AlphaTheme> }) => theme.cardSurface ?? COLORS.white};
  position: relative;
`;

export const DesktopImage = styled.img<{ isActive?: boolean }>`
  width: 100%;
  height: 100%;
  max-width: 373px;
  object-fit: cover;
  object-position: center;
  @media ${device.laptop} {
    opacity: ${({ isActive }) => (isActive ? '1' : '50%')};
  }
  @media ${device.laptopL} {
    max-width: 475px;
  }
`;

export const DesktopTile = styled.div<{ isActive?: boolean }>`
  display: flex;
  flex-direction: row;
  height: 100%;
  opacity: ${({ isActive }) => (isActive ? '1' : '50%')};
  border-radius: ${({ theme }: { theme: Partial<AlphaTheme> }) => theme.borderRadiusSm ?? '0'};
  overflow: hidden;
`;

export const MobileTile = styled.div<{ isActive?: boolean }>`
  display: flex;
  flex-direction: column;
  height: 100%;
  opacity: ${({ isActive }) => (isActive ? '1' : '50%')};
  position: relative;
`;

export const OfferTypeWrapper = styled.div`
  position: absolute;
  top: 16px;
  left: 12px;
  @media ${device.laptop} {
    left: 20px;
  }
`;
